<template>
  <v-footer>
    <v-spacer />
    <p>Need help? Contact us at <a href="mailto:eclass@ualberta.ca">eclass@ualberta.ca</a> or 780-492-9372</p>
    <v-spacer />
  </v-footer>
</template>

<script>
export default {
    name: 'CCFooter',
};
</script>

<style scoped>
.v-footer p a {
    color: #275D38 !important;
    font-weight: 500;
    text-decoration: none;
}
</style>
